<div class="container-fluid bg-white">

  <app-loader *ngIf="isLoading()"></app-loader>

  <div class="page" *ngIf="!isLoading()">

    <div class="page-header alternate">
      <h2 class="page-title alternate-heading text-center">
        <span class="text-primary">{{'View here' | translate}}</span><br />
        <span>{{'all our events' | translate}}</span>
      </h2>
    </div>

    <div class="page-body">

      <div class="container-smaller">

        <div class="content-wrapper">

          <div class="content">

            <h3> {{ 'Upcoming events' | translate}}</h3>

            <div class="grid grid-project">

              <div class="row">

                <div class="col-6 col-sm-4 grid-item grid-item-project grid-item-image-bg" *ngFor="let node of eventsNew()">

                  <a class="grid-item-link" [routerLink]="getLink(node)">

                    <div class="grid-item-image-wrapper" *ngIf="node.imageUri" [ngStyle]="{'background-image' : 'url(' + (node.imageUri ? node.imageUri : '') + ''}">
                      <img class="grid-item-image grid-item-image-project img-fluid" [src]="node.imageUri" />
                    </div>

                    <h3 class="grid-item-title">
                      {{externalpageService.getTranslatedTitle(node)}}
                      <span class="grid-item-date text-xs" *ngIf="node.eventDate"><br /> {{node.eventDate | date: 'dd-MM-YY'}}</span>
                    </h3>
                  </a>
                </div>

              </div>

            </div>

            <h3 class="mt-5">{{ 'Older events' | translate}}</h3>
            <div class="grid grid-project">

              <div class="row">

                <div class="col-6 col-sm-4 grid-item grid-item-project grid-item-image-bg" *ngFor="let node of eventsOld()">

                  <a class="grid-item-link" [routerLink]="getLink(node)">

                    <div class="grid-item-image-wrapper" *ngIf="node.imageUri" [ngStyle]="{'background-image' : 'url(' + (node.imageUri ? node.imageUri : '') + ''}">
                      <img class="grid-item-image grid-item-image-project img-fluid" [src]="node.imageUri" />
                    </div>

                    <h3 class="grid-item-title">
                      {{externalpageService.getTranslatedTitle(node)}}
                      <span class="grid-item-date text-xs" *ngIf="node.eventDate"><br /> {{node.eventDate | date: 'dd-MM-YY'}}</span>
                    </h3>
                  </a>
                </div>

              </div>

            </div>

            <!--            <ngb-pagination (pageChange)="setPage($event)" [(page)]="view.queryParams.pageNumber" [pageSize]="view.queryParams.pageSize" [collectionSize]="view.queryParams.totalItems"></ngb-pagination>-->

          </div>

        </div>

      </div>

    </div>

  </div>

</div>
